import React from 'react';
import styles from './_alert-viewer.module.scss';
import { Alert as MaterialAlert, AlertTitle } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux';
import { Alert } from '../../Data/Alert';
import { removeAlert } from '../../store/Notifications/actions';
import { AppState } from '../../store/rootReducer';


export default function AlertViewer() {
  const dispatch = useDispatch();
  const alerts = useSelector((appState: AppState) => appState.notifications.notifications);
  return (
    <div className={styles.alertViewerContainer}>
      {alerts.length > 0 && (
        <>
          {alerts.map((a: Alert, key) => {
            return (
              <MaterialAlert className={styles.materialAlert} key={key} severity={a.type} variant="filled"
                onClose={() => {
                  dispatch(removeAlert(a.id));
                }}
              >
                <AlertTitle className="capitalize">{a.type}</AlertTitle>
                {a.message}
              </MaterialAlert>
            )
          })}
        </>
      )}
    </div>
  );
}
